import { useQuery } from "react-query";
import { useDispatch } from "react-redux";

import { agentOfficeSetupService } from "services";
import { uiActions } from "store";
import { ErrorResponse } from "types";

const useAgentOfficeListQuery = ({ fetchData }) => {
	const dispatch = useDispatch();

	const { page, filters, sortBy } = fetchData;

	const queryResult = useQuery(
		["agentOfficesQueue", page, filters, sortBy],
		() =>
			agentOfficeSetupService.getAgentOfficesList({
				page,
				sort: sortBy,
				filtersApplied: filters,
			}),
		{
			select: (data: {
				count: number;
				items: { [key: string]: any };
			}) => {
				const agentOffices = data?.items?.map(agentOffice => ({
					officeName: agentOffice.name,
					primaryContact: {
						id: agentOffice.primaryContactId,
						name: agentOffice.primaryContact || "House Account",
					},
					phone: agentOffice.csPhone,
					package: agentOffice.package,
					businessUnit: agentOffice.business_unit,
					businessUnitHierarchy: agentOffice.business_unit_hierarchy,
					ariseAffiliateId: agentOffice.arise_affiliate_id,
					agentOffice,
				}));

				return { count: data?.count, items: agentOffices };
			},

			onError(error: ErrorResponse) {
				dispatch(
					uiActions.showErrorNotification({
						title: error?.title,
					}),
				);
			},
			retry: 0,
			cacheTime: 0,
		},
	);

	return queryResult;
};

export default useAgentOfficeListQuery;
